export enum SolidSurfaceConfigTabs {
    LAYOUT = 1,
    DIMENSIONS = 2,
    SHAPINGS = 3,
    APPLIANCES = 4,
    SPLASHBACKS = 5,
    STYLES = 6,
    SUMMARY = 7
}
